import { CategoryStatus } from '../enums';
import { z } from 'zod';
import { Translation } from './translation';

export const UpdateCategoryTagDto = z
  .object({
    status: z.enum([CategoryStatus.ARCHIVED, CategoryStatus.ACTIVE]).optional(),
    configurables: z.array(z.string().uuid()).optional(),
    translations: z.array(Translation.optional()),
  })
  .strict();

export type ApiUpdateCategoryTagDto = z.infer<typeof UpdateCategoryTagDto>;

export const CreateCategoryTagDto = z.object({
  status: z.enum([CategoryStatus.ARCHIVED, CategoryStatus.ACTIVE]).optional(),
  configurables: z.array(z.string().uuid()).optional(),
  translations: z.array(Translation),
  /**
   * Links a custom-authored tag back to the seeded "macro" tag it was
   * minted from (e.g. a free-typed Service Type entry back to the seeded
   * `additional-service` tag), so entries under the same macro stay
   * groupable later. Validated in-scope by `CategoryTagController.create`.
   */
  parentTagId: z.string().uuid().optional(),
});

export type ApiCreateCategoryTagDto = z.infer<typeof CreateCategoryTagDto>;
